function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function deleteCookie(cname) {
  document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

function setCookie(cname, cvalue, exdays) {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + date.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

const slideAnime = (() => {
  const animatingTargets = new WeakSet();

  return (setOptions) => {
    const defaultOptions = {
      target: false,
      animeType: "slideToggle",
      duration: 250,
      easing: "ease",
      isDisplayStyle: "block",
      parent: false,
      addFunction: () => {},
    };
    const options = Object.assign({}, defaultOptions, setOptions);
    const target = options.target;
    const parent = options.parent;
    if (!target || animatingTargets.has(target)) return false;

    let animeType = options.animeType;
    const styles = getComputedStyle(target);
    if (animeType === "slideToggle") {
      animeType = styles.display === "none" ? "slideDown" : "slideUp";
    }
    if (
      (animeType === "slideUp" && styles.display === "none") ||
      (animeType === "slideDown" && styles.display !== "none") ||
      (animeType !== "slideUp" && animeType !== "slideDown")
    ) {
      return false;
    }
    animatingTargets.add(target);
    target.style.overflow = "hidden";
    const duration = options.duration;
    const easing = options.easing;
    const isDisplayStyle = options.isDisplayStyle;

    if (animeType === "slideDown") {
      target.style.display = isDisplayStyle;
    }
    const heightVal = {
      height: target.getBoundingClientRect().height + "px",
      marginTop: styles.marginTop,
      marginBottom: styles.marginBottom,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
    };

    Object.keys(heightVal).forEach((key) => {
      if (parseFloat(heightVal[key]) === 0) {
        delete heightVal[key];
      }
    });
    if (Object.keys(heightVal).length === 0) {
      target.style.overflow = "";
      if (animeType === "slideDown") target.style.display = "none";
      animatingTargets.delete(target);
      return false;
    }
    parent.classList?.toggle("opened");
    let animation;
    if (animeType === "slideDown") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = 0;
      });
      animation = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    } else if (animeType === "slideUp") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = heightVal[key];
        heightVal[key] = 0;
      });
      animation = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    }
    const finish = (completed) => {
      if (completed) options.addFunction();
      target.style.overflow = "";
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = "";
      });
      if (completed && animeType === "slideUp") {
        target.style.display = "none";
      }
      animatingTargets.delete(target);
    };
    animation.finished.then(() => finish(true), () => finish(false));
    return true;
  };
})();

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = null;
    this.changeEvent = new Event("change", { bubbles: true });
    this.onInputChange = this.onInputChange.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onQuantityUpdate = this.validateQtyRules.bind(this);
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.input = this.querySelector("input");
    if (!this.input) return;
    this.input.addEventListener("change", this.onInputChange);
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick),
    );
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.onQuantityUpdate,
    );
  }

  disconnectedCallback() {
    this.input?.removeEventListener("change", this.onInputChange);
    this.querySelectorAll("button").forEach((button) =>
      button.removeEventListener("click", this.onButtonClick),
    );
    this.quantityUpdateUnsubscriber?.();
    this.quantityUpdateUnsubscriber = undefined;
    this.input = null;
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ||
    event.target.closest("button").name === "plus"
      ? this.input.stepUp()
      : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class CollapsibleBlock extends HTMLElement {
  constructor() {
    super();
    this.onHeadingClick = this.onHeadingClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.onHeadingClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onHeadingClick);
  }

  onHeadingClick(evt) {
    const heading = evt.target.closest?.(".collapsible-heading");
    if (!heading || heading.closest("collapsible-block") !== this) return;
    if (slideAnime({
      target: heading.parentElement.querySelector(".collapsible-content"),
      animeType: "slideToggle",
    }) === false) return;
    this.classList.toggle("active");
  }
}
customElements.define("collapsible-block", CollapsibleBlock);

async function copyNewsletterCode(copyButton, couponCode) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(couponCode);
  } else {
    const textarea = document.createElement("textarea");
    textarea.value = couponCode;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, couponCode.length);
    document.execCommand("copy");
    textarea.remove();
  }

  copyButton.classList.add("is-copied");
  const feedback = copyButton.querySelector?.(
    "[data-newsletter-copy-feedback]",
  );
  const copyBubble = copyButton.querySelector?.(
    "[data-newsletter-copy-bubble]",
  );
  if (feedback) feedback.textContent = "Copied!";
  if (copyBubble) copyBubble.hidden = false;

  if (copyButton.newsletterCopyResetTimer) {
    window.clearTimeout(copyButton.newsletterCopyResetTimer);
  }
  copyButton.newsletterCopyResetTimer = window.setTimeout(() => {
    copyButton.classList.remove("is-copied");
    if (feedback) feedback.textContent = "";
    if (copyBubble) copyBubble.hidden = true;
    copyButton.newsletterCopyResetTimer = null;
  }, 2000);
}

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.teaserButton = null; // Teaser 按钮元素
    this.contentPromise = null;
    this.initTimer = null;
    this.idleCallbackId = null;
    this.loadHandler = null;
    this.autoInitStarted = false;
  }

  connectedCallback() {
    if (!this.autoInitStarted) this.scheduleInit();
  }

  disconnectedCallback() {
    if (this.loadHandler) window.removeEventListener("load", this.loadHandler);
    this.loadHandler = null;
    if (this.initTimer !== null) window.clearTimeout(this.initTimer);
    this.initTimer = null;
    if (this.idleCallbackId !== null) window.cancelIdleCallback?.(this.idleCallbackId);
    this.idleCallbackId = null;
    this.removeTeaserButton();
  }

  scheduleInit() {
    if (this.initTimer !== null || this.idleCallbackId !== null || this.loadHandler) return;
    const startInit = () => {
      this.loadHandler = null;
      const delay = window.Shopify?.designMode ? 0 : 8000;

      this.initTimer = window.setTimeout(() => {
        this.initTimer = null;
        if (!this.isConnected || this.autoInitStarted) return;
        const runInit = () => {
          this.idleCallbackId = null;
          if (!this.isConnected || this.autoInitStarted) return;
          this.autoInitStarted = true;
          this.init();
        };

        if ("requestIdleCallback" in window) {
          this.idleCallbackId = window.requestIdleCallback(runInit, { timeout: 3000 });
          return;
        }

        runInit();
      }, delay);
    };

    if (document.readyState === "complete") {
      startInit();
      return;
    }

    this.loadHandler = startInit;
    window.addEventListener("load", startInit, { once: true });
  }

  async init() {
    if (!this.dataset.show) return;
    // 自动展示被关闭时不下载内容；编辑器仍保留原来的预加载行为。
    if (!Shopify.designMode && !this.shouldAutoOpen()) return;

    try {
      await this.loadNewsletterContent();
    } catch (error) {
      console.error("Error initializing newsletter popup:", error);
    } finally {
      if (this.isConnected) this.initPopup();
      else this.autoInitStarted = false;
    }
  }

  async loadNewsletterContent() {
    const currentContent = this.querySelector(".popup-content");
    if (currentContent) return currentContent;
    if (this.contentPromise) return this.contentPromise;

    this.contentPromise = (async () => {
      const sectionId = this.dataset.sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&ajax=1`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Fetch error: ${response.status}`);
      }

      const responseText = await response.text();
      const newSection = new DOMParser()
        .parseFromString(responseText, "text/html")
        .querySelector("newsletter-popup")?.innerHTML;

      if (newSection) this.innerHTML = newSection;
      return this.querySelector(".popup-content");
    })();

    try {
      return await this.contentPromise;
    } finally {
      this.contentPromise = null;
    }
  }

  handleNewsletterSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    if (!form) return null;

    const submit = () => form.submit();
    const captchaProtect = window.Shopify?.captcha?.protect;

    if (typeof captchaProtect !== "function") {
      submit();
      return null;
    }

    captchaProtect(form, submit);
    return null;
  }

  setNewsletterState(popupRoot, state) {
    if (!popupRoot) return;

    const formState = popupRoot.querySelector('[data-newsletter-state="form"]');
    const successState = popupRoot.querySelector('[data-newsletter-state="success"]');
    const showSuccess = state === "success";

    if (formState) formState.hidden = showSuccess;
    if (successState) successState.hidden = !showSuccess;

    if (showSuccess) {
      popupRoot.querySelector("[data-newsletter-success-heading]")?.focus({
        preventScroll: true,
      });
    }
  }

  getPopupWidth(popupContent = this.querySelector(".popup-content")) {
    return popupContent?.style.getPropertyValue("--popup-max-width") || "800px";
  }

  async openPopup(initialState = "form") {
    if (!window.themePopup) {
      console.warn("[newsletter-popup] theme-popup is not available.");
      return null;
    }

    const showMobile = this.dataset.showMb === "true";
    let popupContent;

    try {
      popupContent = await this.loadNewsletterContent();
    } catch (error) {
      console.error("Error loading newsletter popup:", error);
      return null;
    }

    if (!popupContent) {
      console.warn("[newsletter-popup] popup content is not available.");
      return null;
    }
    if (!this.isConnected) return null;

    const popup = window.themePopup.open({
      id: "newsletter",
      content: popupContent.outerHTML,
      className: [
        "newsletter-popup-modal",
        `${showMobile ? "show-all" : "disable-on-mobile"}`,
      ],
      ariaLabel: "Newsletter signup",
      flushContent: true,
      mobilePosition: "center",
      size: "medium",
      width: this.getPopupWidth(popupContent),
      onMount: (popupRoot) => {
        this.onShowNewsletter(popupRoot, initialState);
      },
    });

    if (!popup) return null;

    if (initialState === "success") {
      this.removeTeaserButton();
    } else {
      this.showTeaserButton();
    }

    return popup;
  }

  shouldAutoOpen() {
    const showType = this.dataset.show;
    const showMobile = this.dataset.showMb === "true";
    const isMobile = window.innerWidth < 768;

    return !Shopify.designMode &&
      (showType === "show_homepage" || showType === "show_all_page") &&
      (!isMobile || showMobile) &&
      !getCookie("newsletter_popup");
  }

  initPopup() {
    // 请求完成后再次检查，防止等待期间用户已关闭自动展示。
    if (this.shouldAutoOpen()) {
      this.openPopup();
    }
  }

  initPopup2() {
    const showType = this.dataset.show;
    const showMobile = this.dataset.showMb === "true";
    const isMobile = window.innerWidth < 768;

    if (!Shopify.designMode) {
      if (!showMobile && isMobile) return;

      if (showType === "show_homepage" || showType === "show_all_page") {
        this.openPopup();
      }
    }
  }

  onShowNewsletter(popupRoot, initialState = "form") {
    if (!popupRoot) return;

    this.setNewsletterState(popupRoot, initialState);

    const dontShowButton = popupRoot.querySelector(
      ".newsletter-popup__dont-show",
    );
    const form = popupRoot.querySelector("#newsletter-popup-form");
    const emailInput = form?.querySelector("[data-newsletter-email]");
    const copyButton = popupRoot.querySelector("[data-newsletter-copy-code]");

    dontShowButton?.addEventListener("click", this.notShow.bind(this));
    form?.addEventListener("submit", (event) => {
      this.handleNewsletterSubmit(event);
    });
    emailInput?.addEventListener("invalid", () => {
      emailInput.setCustomValidity(
        emailInput.validity.valueMissing
          ? "Please enter your email address."
          : "Please enter a valid email address.",
      );
    });
    emailInput?.addEventListener("input", () => {
      emailInput.setCustomValidity("");
    });
    copyButton?.addEventListener("click", () => {
      copyNewsletterCode(
        copyButton,
        copyButton.dataset.newsletterCopyCode || "NEW20",
      ).catch((error) => {
        console.error("Error copying newsletter coupon:", error);
      });
    });
  }

  notShow(event) {
    event.preventDefault();
    setCookie("newsletter_popup", 30, 1);

    window.themePopup?.close("newsletter");
  }

  showTeaserButton() {
    if (this.teaserButton) return; // 防止重复创建按钮

    const teaserContainer = document.createElement("div");

    teaserContainer.classList.add("new-teaser-button-wrapper");
    const teaserButton = document.createElement("button");
    teaserButton.innerHTML = "Get Extra 20% Off";

    teaserButton.addEventListener("click", () => this.initPopup2());
    teaserButton.classList.add("new-teaser-button");
    const closeButton = document.createElement("button");
    closeButton.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true" focusable="false"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg>';
    closeButton.setAttribute("aria-label", "Close teaser");
    closeButton.classList.add("new-teaser-button-close");

    closeButton.addEventListener("click", () => {
      teaserContainer.remove();
      this.teaserButton = null;
    });

    teaserContainer.appendChild(teaserButton);
    teaserContainer.appendChild(closeButton);
    document.body.appendChild(teaserContainer);

    this.teaserButton = teaserContainer;
  }

  removeTeaserButton() {
    this.teaserButton?.remove();
    this.teaserButton = null;
  }
}

// 注册自定义元素
customElements.define("newsletter-popup", NewsletterPopup);

var returnMessageWhenSubmit = (function () {
  return {
    init: function () {
      this.checkUrlReturn();
    },
    checkUrlReturn: async function () {
      const returnUrl = new URL(window.location.href);
      const customerPosted =
        returnUrl.searchParams.get("customer_posted") === "true";
      const isNewsletterPopupReturn =
        returnUrl.hash === "#newsletter-popup-form";
      const isNewsletterError =
        returnUrl.searchParams.get("contact[tags]") === "newsletter" &&
        returnUrl.searchParams.get("form_type") === "customer";
      const clearReturnUrl = () => {
        window.history.replaceState(
          window.history.state,
          document.title,
          returnUrl.pathname,
        );
      };
      if (customerPosted && isNewsletterPopupReturn) {
        const successPopup = await this.handleMessageSuccessPopup(true);
        if (!successPopup) return;

        setCookie("newsletter_popup", 30, 30);
        clearReturnUrl();
      } else if (customerPosted) {
        this.handleMessageSuccessPopup(false).catch((error) => {
          console.error("Error opening newsletter success popup:", error);
        });
        setCookie("newsletter_popup", 30, 1);
        clearReturnUrl();
      }

      if (isNewsletterError) {
        this.handleMessageErrorPopup();
        clearReturnUrl();
      }
    },

    handleMessageSuccessPopup: async function (useNewsletterPopup = false) {
      const newsletterPopup = useNewsletterPopup
        ? document.querySelector("newsletter-popup")
        : null;
      let newsletterPopupPromise = null;
      if (newsletterPopup) {
        newsletterPopupPromise = newsletterPopup.openPopup("success");
      }

      if (newsletterPopupPromise) {
        try {
          const popup = await newsletterPopupPromise;
          if (popup) return popup;
        } catch (error) {
          console.error("Error opening newsletter success popup:", error);
        }
      }

      const openSuccessFallback = () => {
        const fallbackContent = document.querySelector(
          "[data-newsletter-success-fallback]",
        )?.content?.querySelector(".popup-content");
        if (!window.themePopup || !fallbackContent) return null;

        const showMobile =
          !newsletterPopup || newsletterPopup.dataset.showMb === "true";
        const popup = window.themePopup.open({
          id: "newsletter-success",
          content: fallbackContent.outerHTML,
          className: [
            "newsletter-popup-modal",
            showMobile ? "show-all" : "disable-on-mobile",
          ],
          ariaLabel: "Newsletter signup success",
          flushContent: true,
          mobilePosition: "center",
          size: "medium",
          width:
            newsletterPopup?.getPopupWidth?.(fallbackContent) ||
            "var(--ds-container-md)",
          onMount: (popupRoot) => {
            if (newsletterPopup) {
              newsletterPopup.onShowNewsletter(popupRoot, "success");
              return;
            }

            const successState = popupRoot.querySelector(
              '[data-newsletter-state="success"]',
            );
            if (successState) successState.hidden = false;
            popupRoot.querySelector("[data-newsletter-success-heading]")?.focus({
              preventScroll: true,
            });
            const copyButton = popupRoot.querySelector("[data-newsletter-copy-code]");
            copyButton?.addEventListener("click", () => {
              copyNewsletterCode(
                copyButton,
                copyButton.dataset.newsletterCopyCode || "NEW20",
              ).catch((error) => {
                console.error("Error copying newsletter coupon:", error);
              });
            });
          },
        });

        if (popup) newsletterPopup?.removeTeaserButton();
        return popup;
      };

      const popup = openSuccessFallback();
      if (popup) return popup;

      // Keep the legacy toast only when the shared popup cannot open.
      const url = `${window.location.pathname}?section_id=form-message`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          const elementSuccessMessage = html.querySelector(
            ".newsletter-form__success-message-wrapper",
          );
          if (!elementSuccessMessage) return;

          showToast(elementSuccessMessage.innerHTML, 5000, "modal-success");
        })
        .catch((error) => {
          console.error("Error loading newsletter success message:", error);
        });
      return null;
    },

    handleMessageErrorPopup: async function () {
      const url = `${window.location.pathname}?section_id=form-message`;
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Newsletter error message request failed: ${response.status}`);
        }
        const html = new DOMParser().parseFromString(
          await response.text(),
          "text/html",
        );
        const message = html.querySelector(
          ".newsletter-form__error-message-wrapper",
        );
        showToast(
          message?.innerHTML || "We couldn't process your subscription. Please try again.",
          5000,
          "modal-error",
        );
      } catch (error) {
        console.error("Error loading newsletter error message:", error);
        showToast(
          "We couldn't process your subscription. Please try again.",
          5000,
          "modal-error",
        );
      }
    },
  };
})();
returnMessageWhenSubmit.init();
class PaginateLoadmore extends HTMLElement {
  connectedCallback() {
    this.initLoadMore();
  }
  disconnectedCallback() {
    this.searchObserver?.disconnect();
    this.loadMoreObserver?.disconnect();
    this.searchObserver = null;
    this.loadMoreObserver = null;
    this.cancelSearchLoad();
    this.searchRequest = null;
    this.loadMoreRequest?.abort();
    this.loadMoreRequest = null;
    this.loadingMore = false;
    this.querySelectorAll('.actions-loadmore').forEach((target) => {
      this.toggleLoading(target, false);
      target.removeAttribute('aria-disabled');
    });
    this.searchGrid?.removeAttribute('aria-busy');
    this.searchGrid = null;
    this.loadMoreEvents?.abort();
  }
  cancelSearchLoad() {
    this.searchRequest?.abort();
  }
  initLoadMore() {
    this.loadMoreEvents = new AbortController();
    this.querySelectorAll(".actions-loadmore").forEach((loadMore) => {
      if (loadMore.hasAttribute('data-next-url') && this.hasAttribute('data-search-loadmore')) {
        this.searchObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadSearchBatch(loadMore);
        });
        this.searchObserver.observe(loadMore);
        return;
      }
      if (loadMore.classList.contains("infinit-scrolling")) {
        this.loadMoreObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1) {
                this.loadMoreItem(loadMore);
              }
            });
          },
          { threshold: 1.0 },
        );
        this.loadMoreObserver.observe(loadMore);
      } else {
        if (this.hasAttribute('data-search-loadmore')) {
          loadMore.addEventListener('keydown', (event) => {
            if (event.key !== ' ') return;
            event.preventDefault();
            this.loadMoreItem(loadMore);
          }, { signal: this.loadMoreEvents.signal });
        }
        loadMore.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            this.loadMoreItem(target);
          },
          { signal: this.loadMoreEvents.signal },
        );
      }
    });
  }
  loadMoreItem(target) {
    if (this.hasAttribute('data-search-loadmore')) return this.loadSearchBatch(target);
    if (this.loadingMore) return;
    const section = this.closest(".sec__collection-main, .main-blog");
    const list = section?.querySelector(".loadmore-lists");
    const loadMore_url = target.getAttribute("href");
    if (!list || !loadMore_url) return;
    this.loadingMore = true;
    this.toggleLoading(target, true);
    const request = this.loadMoreRequest = new AbortController();
    fetch(loadMore_url, { signal: request.signal })
      .then((response) => {
        if (!response.ok) throw new Error(`Load more request failed: ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        if (request.signal.aborted || !this.isConnected) return;
        const resultNodes = parser.parseFromString(responseText, "text/html");
        const nextSection = resultNodes.querySelector(
          section.classList.contains("main-blog") ? ".main-blog" : ".sec__collection-main",
        );
        const nextList = nextSection?.querySelector(".loadmore-lists");
        if (!nextList) throw new Error("Missing load more list in section response");
        const existingStyles = new Set(
          [...section.querySelectorAll('style[data-section-stylesheet]')].map((style) => style.textContent),
        );
        resultNodes.querySelectorAll('style[data-section-stylesheet]').forEach((style) => {
          if (existingStyles.has(style.textContent)) return;
          existingStyles.add(style.textContent);
          section.appendChild(style);
        });
        const responsiveClasses = ["ds-hide-md", "ds-hide-mobile"];
        const nextPagination = [...nextSection.querySelectorAll("loadmore-button")].find(
          (candidate) => responsiveClasses.every(
            (className) => candidate.classList.contains(className) === this.classList.contains(className),
          ),
        );
        const fragment = document.createDocumentFragment();
        nextList.querySelectorAll(":scope > .loadmore-item").forEach((item) => fragment.appendChild(item));
        list.appendChild(fragment);
        window.productItemVideoReveal?.init(list);
        const nextLink = nextPagination?.querySelector(".actions-loadmore[href]");
        if (nextLink) {
          target.setAttribute("href", nextLink.getAttribute("href"));
        } else {
          this.loadMoreObserver?.disconnect();
          target.remove();
        }
      })
      .catch((error) => {
        if (!request.signal.aborted && this.isConnected) console.error("Unable to load more results", error);
      })
      .finally(() => {
        if (this.loadMoreRequest !== request) return;
        this.loadMoreRequest = null;
        this.loadingMore = false;
        this.toggleLoading(target, false);
      });
  }
  // Search keeps one typed result set and follows Shopify's next URL, without deriving page counts.
  async loadSearchBatch(target) {
    if (this.searchRequest || this.filterPending || target.hidden) return;
    const section = this.closest('.search-page');
    const grid = section?.querySelector('#product-grid');
    if (!grid) return;
    const request = this.searchRequest = new AbortController();
    this.searchGrid = grid;
    const status = this.querySelector('[data-search-loadmore-status]');
    const nextAttribute = this.searchObserver ? 'data-next-url' : 'href';
    const url = new URL(target.getAttribute(nextAttribute), location.href);
    let recheckIntersection = false;
    url.searchParams.set('section_id', section.dataset.sectionId);
    this.toggleLoading(target, true);
    target.setAttribute('aria-disabled', 'true');
    grid.setAttribute('aria-busy', 'true');
    status.textContent = 'Loading more results…';
    status.classList.add('visually-hidden');
    try {
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (request.signal.aborted || !this.isConnected) return;
      const nextSection = parsed.querySelector('.search-page');
      const nextGrid = nextSection?.querySelector('#product-grid');
      if (nextSection?.dataset.sectionId !== section.dataset.sectionId ||
          (!nextGrid && !nextSection.querySelector('[data-search-empty]'))) {
        throw new Error('Missing search results in section response');
      }
      const items = [...(nextGrid?.querySelectorAll(':scope > .loadmore-item') || [])];
      const resultKey = (item) => {
        const link = item.querySelector('a[href]');
        return link ? new URL(link.getAttribute('href'), location.origin).pathname : null;
      };
      const seen = new Set([...grid.children].map(resultKey).filter(Boolean));
      const fresh = items.filter((item) => {
        const key = resultKey(item);
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
      // Section-only styles must survive extraction, including article/page card styles.
      parsed.querySelectorAll('style[data-section-stylesheet]').forEach((style) => {
        if (![...section.querySelectorAll('style[data-section-stylesheet]')]
          .some((existing) => existing.textContent === style.textContent)) section.append(style);
      });
      grid.append(...fresh);
      window.productItemVideoReveal?.init(grid);
      const count = section.querySelector('[data-search-count]');
      if (count) count.textContent = `${grid.querySelectorAll(':scope > .loadmore-item').length} ${count.dataset.searchLabel} shown`;
      const nextLink = nextSection.querySelector('[data-search-loadmore] .actions-loadmore');
      const nextUrl = nextLink ? new URL(nextLink.getAttribute(nextAttribute), location.href) : null;
      nextUrl?.searchParams.delete('section_id');
      const currentUrl = new URL(url);
      currentUrl.searchParams.delete('section_id');
      const hasMore = items.length > 0 && nextUrl && nextUrl.href !== currentUrl.href;
      const hadFocus = document.activeElement === target;
      target.hidden = !hasMore;
      if (hasMore) target.setAttribute(nextAttribute, nextUrl.href);
      else this.searchObserver?.disconnect();
      recheckIntersection = Boolean(hasMore);
      status.textContent = items.length === 0 ? 'No additional results were returned. Try a different keyword or filter.' :
        `${fresh.length} more results loaded.${hasMore ? (fresh.length ? '' : ' Try loading the next batch.') : ' No further results were returned.'}`;
      if (hadFocus) {
        const focusTarget = fresh[0]?.querySelector('a[href]') || (hasMore ? target : status);
        focusTarget.focus({ preventScroll: true });
      }
    } catch (error) {
      if (!request.signal.aborted && this.isConnected) {
        status.textContent = this.searchObserver ? 'Unable to load more results. Scroll away and back to retry.' :
          'Unable to load more results. Please try again.';
        if (this.searchObserver) status.classList.remove('visually-hidden');
      }
    } finally {
      if (this.searchRequest === request) {
        this.searchRequest = null;
        this.toggleLoading(target, false);
        target.removeAttribute('aria-disabled');
        grid.removeAttribute('aria-busy');
        this.searchGrid = null;
        // Recheck after appending: a short or duplicate batch may leave the sentinel in view.
        if (recheckIntersection && this.searchObserver && this.isConnected && !request.signal.aborted) {
          this.searchObserver.unobserve(target);
          this.searchObserver.observe(target);
        }
      }
    }
  }
  toggleLoading(event, loading) {
    if (event) {
      const method = loading ? "add" : "remove";
      event.classList[method]("loading");
    }
  }
}
customElements.define("loadmore-button", PaginateLoadmore);

class TermsConditions extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.init();
  }
  init() {
    const terms = this.querySelector("a");
    if (terms) {
      terms.addEventListener("click", (e) => {
        const popup = document.querySelector("#popup-terms-conditions");
        if (popup && window.themePopup) {
          e.preventDefault();
          window.themePopup.open({
            id: "terms-conditions",
            title: popup.getAttribute("data-text"),
            content: popup.querySelector(".terms-conditions-content").outerHTML,
          });
        }
      });
    }
    const conditions = this.querySelector(".conditions_form_product");
    const dynamicCheckout = this.closest("product-form")?.querySelector(
      ".btn-checkout-dynamic",
    );
    if (conditions) {
      if (getCookie("term_conditions")) {
        conditions.setAttribute("checked", "");
        if (dynamicCheckout) {
          dynamicCheckout.classList.remove("disabled");
        }
      }
      conditions.addEventListener("change", (event) => {
        if (dynamicCheckout) {
          if (event.currentTarget.checked) {
            dynamicCheckout.classList.remove("disabled");
            setCookie("term_conditions", 1, 1);
          } else {
            dynamicCheckout.classList.add("disabled");
            deleteCookie("term_conditions");
          }
        }
      });
    }
  }
}
customElements.define("terms-conditions", TermsConditions);

class SwatchFunctions extends SwatchInit {
  init() {
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      this.checkSwatches(btn);
    });
    this.initAction();
  }

  initAction() {
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(e) {
    this.productTarget = this.closest(".product__item-js");
    const target = e.target;
    const variantQtyData = JSON.parse(
      this.productTarget.querySelector(".productVariantsQty").textContent,
    );
    this.groupFunctionsInit();
    if (!this.currentVariant) {
      this.groupFunctionsUnavailable(target);
    } else {
      this.groupFunctionsAvailable(variantQtyData, target);
    }
  }
  groupFunctionsInit() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
  }
  groupFunctionsUnavailable(target) {
    this.toggleAddButton(true, "", true);
    this.setUnavailable(target);
  }
  updatePrice(productTarget) {
    if (!this.currentVariant) return;
    if (!productTarget) return;
    const p = document.getElementById(`price-${this.dataset.section}`);
    if (p) p.classList.remove("visibility-hidden");
    const compare_at_price = this.currentVariant.compare_at_price;
    const price = this.currentVariant.price;
    const unit_price = this.currentVariant.unit_price;
    const unit_price_measurement = this.currentVariant.unit_price_measurement;
    const price_format = Shopify.formatMoney(
      this.currentVariant.price,
      themeGlobalVariables.settings.money_format,
    );
    if (unit_price && unit_price_measurement) {
      const price_num = Shopify.formatMoney(
        unit_price,
        themeGlobalVariables.settings.money_format,
      );
      const price_unit =
        unit_price_measurement.reference_value != 1
          ? unit_price_measurement.reference_value
          : unit_price_measurement.reference_unit;
      if (productTarget.querySelector(".unit-price .number")) {
        productTarget.querySelector(".unit-price .number").innerHTML =
          price_num;
      }
      if (productTarget.querySelector(".unit-price .unit")) {
        productTarget.querySelector(".unit-price .unit").innerHTML = price_unit;
      }
    }
    if (productTarget.querySelector(".price-regular .price")) {
      productTarget.querySelector(".price-regular .price").innerHTML =
        price_format;
    }
    const bls__price = productTarget.querySelector(
      ".product-detail__price .card-product-price",
    );
    if (bls__price) {
      if (!bls__price.querySelector(".compare-price")) {
        var ps = document.createElement("div");
        var sp = document.createElement("span");
        var cp = document.createElement("s");
        cp.classList.add("price-item", "compare-price");
        sp.appendChild(cp);
        ps.appendChild(sp);
        ps.classList.add("price-regular");
        if (productTarget.querySelector(".card-product-price")) {
          productTarget.querySelector(".card-product-price").appendChild(ps);
        }
      }
      const cpp = bls__price.querySelector(".compare-price");

      if (cpp) {
        if (compare_at_price && compare_at_price > price) {
          const compare_format = Shopify.formatMoney(
            compare_at_price,
            themeGlobalVariables.settings.money_format,
          );
          cpp.innerHTML = compare_format;
          if (bls__price.querySelector(".price-regular")) {
            bls__price
              .querySelector(".price-regular")
              .classList.add("primary-color");
          }
          if (bls__price.querySelector(".price-regular .price")) {
            bls__price
              .querySelector(".price-regular .price")
              .classList.add("price--special");
          }
        } else {
          cpp.innerHTML = "";
          if (bls__price.querySelector(".price-regular")) {
            bls__price
              .querySelector(".price-regular")
              .classList.remove("primary-color");
          }
          if (bls__price.querySelector(".price-regular .price")) {
            bls__price.querySelector(".price-regular .price").innerHTML =
              price_format;
            bls__price
              .querySelector(".price-regular .price")
              .classList.remove("price--special");
          }
        }
        if (!this.currentVariant.available) {
          bls__price.classList.add("price--sold-out");
        }
      }
    }
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (this.productTarget?._syncProductViewPurchaseState) {
      this.productTarget._syncProductViewPurchaseState(this.currentVariant?.available === true);
      if (text) addButtonText.textContent = text;
      return;
    }
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
  setUnavailable(target) {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`,
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`,
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`,
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`,
    );

    if (target) {
      const fieldset = target.closest("fieldset");
      const val = target.value;
      const optionSelected = fieldset.querySelector(".option_value");
      optionSelected.textContent = val;
    }
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  setAvailable() {
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`,
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`,
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`,
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`,
    );

    if (price && price.classList.contains("hidden"))
      price.classList.remove("hidden");
    if (inventory && inventory.classList.contains("hidden"))
      inventory.classList.remove("hidden");
    if (sku && sku.classList.contains("hidden")) sku.classList.remove("hidden");
    if (pricePerItem && pricePerItem.classList.contains("hidden"))
      pricePerItem.classList.remove("hidden");
    if (volumeNote && volumeNote.classList.contains("hidden"))
      volumeNote.classList.remove("hidden");
    if (volumeTable && volumeTable.classList.contains("hidden"))
      volumeTable.classList.remove("hidden");
    if (qtyRules && qtyRules.classList.contains("hidden"))
      qtyRules.classList.remove("hidden");
  }
  renderProductInfor(productTarget, variantQtyData, target) {
    if (!this.currentVariant) return;
    if (!productTarget) return;
    let qty = 0;
    let percent = 0;
    let sale = false;
    let soldOut = false;
    let pre_order = false;
    let av = this.currentVariant.available;
    let sku = this.currentVariant.sku;
    let im = this.currentVariant.inventory_management;
    const compare_at_price = this.currentVariant.compare_at_price;

    const price = this.currentVariant.price;
    let avaiable = productTarget.querySelector(".available-value");
    let sku_area = productTarget.querySelector(".product__sku");
    // Update option labels
    const productDetailPicker = productTarget.querySelector(
      ".product-detail__variant-picker",
    );
    if (productDetailPicker) {
      const type = productDetailPicker.dataset.type || "swatches";

      const updateOptionValues = (selector) => {
        const optionElements = productTarget.querySelectorAll(selector);
        optionElements.forEach((element, index) => {
          const optionValue = this.currentVariant[`option${index + 1}`];
          if (optionValue && element.innerHTML !== optionValue) {
            element.innerHTML = optionValue;
          }
        });
      };

      if (type === "swatches") {
        updateOptionValues(".option_value");
      } else {
        updateOptionValues(".option_drop_value .option_value");
        updateOptionValues("swatch-dropdown-select-value .option_value");

        const closestSwatchDropdown = target.closest("swatch-dropdown");
        if (
          closestSwatchDropdown &&
          closestSwatchDropdown.classList.contains("active")
        ) {
          closestSwatchDropdown.classList.remove("active");
        }
      }
    }

    if (sku_area) sku_area.innerHTML = sku ? sku : "N/A";
    variantQtyData.find((variantQty) => {
      if (variantQty.id === this.currentVariant.id) {
        qty = variantQty.qty;
      }
    });

    const countdown = document.querySelector("stock-countdown");
    if (countdown) {
      const itemsLeft = countdown.dataset.itemsLeft;
      const message = countdown.dataset.message;
      if (itemsLeft >= qty && message && qty >= 1) {
        countdown.classList.add("block");
        countdown.classList.remove("hidden");
        const qt = countdown.querySelector("span.count");
        const progressbar = countdown.querySelector(".progressbar-stock");
        let widthProgress;
        if ((qty / itemsLeft) * 100 > 100) {
          widthProgress = 100;
        } else {
          widthProgress = (qty / itemsLeft) * 100;
        }
        progressbar.style.width = widthProgress + "%";
        if (qt) {
          qt.innerHTML = qty;
        }
      } else {
        countdown.classList.remove("block");
        countdown.classList.add("hidden");
      }
    }

    // 折扣类型保存在容器上，不能依赖无折扣时会被移除的标签。
    const typePercent =
      productTarget.querySelector(".product__badges")?.dataset.saleType === "percent";
    if (compare_at_price && compare_at_price > price) {
      sale = true;
      if (typePercent) {
        percent = ((compare_at_price - price) / compare_at_price) * 100;
      } else {
        percent = compare_at_price - price;
      }
    }
    if (im === null) {
      soldOut = false;
      pre_order = false;
      if (avaiable) {
        avaiable.innerHTML = window.variantStrings.inStock;
      }
    } else {
      if (av) {
        if (qty < 1) {
          pre_order = true;
          if (avaiable) {
            avaiable.innerHTML = window.variantStrings.preOrder;
          }
        } else {
          soldOut = false;
          pre_order = false;
          if (avaiable) {
            avaiable.innerHTML = window.variantStrings.inStock;
          }
        }
      } else {
        soldOut = true;
        if (avaiable) {
          avaiable.innerHTML = window.variantStrings.outStock;
        }
      }
    }
    this.renderLabel(sale, pre_order, soldOut, percent, productTarget);
    this.renderBtnStatus(productTarget, im, av, qty);
  }
  renderLabel(sale, pre_order, soldOut, percent, productTarget) {
    const label = productTarget.querySelector(".product__badges");
    const sale_badge = productTarget.querySelector(".sale_badge");
    if (sale || pre_order || soldOut) {
      if (!label) {
        var element = document.createElement("div");
        element.classList.add(
          "product__badges",
          "fs-small",
          "flex",
          "flex-wrap",
          "gap-5",
          "uppercase",
        );
        if (sale_badge) {
          sale_badge.appendChild(element);
        }
      }
    }

    if (label) {
      const saleColor = label.dataset.saleColor;
      const soldOutColor = label.dataset.soldOutColor;
      const preOrderColor = label.dataset.preOrderColor;
      const saleBg = label.dataset.saleBg;
      const soldOutBg = label.dataset.soldOutBg;
      const preOrderBg = label.dataset.preOrderBg;
      const show_sale = label?.dataset.showSale === "true";
      const show_pre_order = label?.dataset.showPreorder === "true";
      const show_sold_out = label?.dataset.showSoldOut === "true";
      const prd = Shopify.formatMoney(
        percent,
        themeGlobalVariables.settings.money_format,
      );
      let dsale = label.querySelector(".product__badges-sale");
      const dsoldout = label.querySelector(".product__badges-sold-out");
      const dpreorder = label.querySelector(".product__badges-pre-order");
      const saleType = label.dataset.saleType;
      if (sale && show_sale) {
        if (!dsale) {
          var elementsale = document.createElement("div");
          elementsale.classList.add(
            "product__badges-sale",
            "product__badges-inner",
            "py-8",
            "px-15",
            "align-self-start",
            "sale",
            "inline-flex",
            "content-center",
            "subheading_weight",
            "btn-rounded",
            "lh-normal",
            "text-center",
          );
          elementsale.style.setProperty("--badges-color", saleColor);
          elementsale.style.setProperty("--badges-bg", saleBg);
          if (saleType === "price" || saleType === "percent") {
            elementsale.classList.add(`product__badges-type-${saleType}`);
          }
          if (dsoldout) {
            label.insertBefore(elementsale, dsoldout);
          } else if (dpreorder) {
            label.insertBefore(elementsale, dpreorder);
          } else {
            label.appendChild(elementsale);
          }
          dsale = elementsale;
        }
        if (saleType === "price") {
          const saleLabel = `${
            window.variantStrings.save ? window.variantStrings.save : "Save"
          } ${prd}`;
          if (dsale.innerHTML !== saleLabel) dsale.innerHTML = saleLabel;
        } else if (saleType === "percent") {
          const saleLabel = "SAVE " + percent.toFixed(0) + "%";
          if (dsale.textContent !== saleLabel) dsale.textContent = saleLabel;
        } else {
          if (dsale.textContent !== label.dataset.saleLabel) {
            dsale.textContent = label.dataset.saleLabel;
          }
        }
      } else {
        dsale?.remove();
      }
      if (pre_order && show_pre_order) {
        if (!dpreorder) {
          var elementpo = document.createElement("div");
          elementpo.classList.add(
            "product__badges-pre-order",
            "product__badges-inner",
            "py-8",
            "px-15",
            "align-self-start",
            "pre-order",
            "inline-flex",
            "content-center",
            "subheading_weight",
            "btn-rounded",
            "lh-normal",
            "text-center",
          );
          elementpo.style.setProperty("--badges-color", preOrderColor);
          elementpo.style.setProperty("--badges-bg", preOrderBg);
          elementpo.innerHTML = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : "Pre-order";
          label.appendChild(elementpo);
        } else {
          const preOrderLabel = window.variantStrings.preOrder
            ? window.variantStrings.preOrder
            : "Pre-order";
          if (dpreorder.innerHTML !== preOrderLabel) dpreorder.innerHTML = preOrderLabel;
        }
      } else {
        dpreorder?.remove();
      }
      if (soldOut && show_sold_out) {
        if (!dsoldout) {
          var elementso = document.createElement("div");
          elementso.classList.add(
            "product__badges-sold-out",
            "product__badges-inner",
            "py-8",
            "px-15",
            "align-self-start",
            "sold-out",
            "inline-flex",
            "content-center",
            "subheading_weight",
            "btn-rounded",
            "lh-normal",
            "text-center",
          );
          elementso.style.setProperty("--badges-color", soldOutColor);
          elementso.style.setProperty("--badges-bg", soldOutBg);
          elementso.innerHTML = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : "Sold out";
          label.appendChild(elementso);
        } else {
          const soldOutLabel = window.variantStrings.soldOut
            ? window.variantStrings.soldOut
            : "Sold out";
          if (dsoldout.innerHTML !== soldOutLabel) dsoldout.innerHTML = soldOutLabel;
        }
      } else {
        dsoldout?.remove();
      }
    }
  }
  renderBtnStatus(productTarget, im, av, qty) {
    if (!productTarget) return;
    let btns_add_cart = productTarget.querySelectorAll(
      ".product_submit_button",
    );
    btns_add_cart.forEach((btn_add_cart) => {
      const btnLabel = btn_add_cart.querySelector(".btn-label");
      if (btnLabel) {
        if (im === null) {
          if (btnLabel.innerHTML !== window.variantStrings.addToCart) {
            btnLabel.innerHTML = window.variantStrings.addToCart;
          }
          btn_add_cart.disabled = false;
        } else {
          if (av) {
            if (qty < 1) {
              if (btnLabel.innerHTML !== window.variantStrings.preOrder) {
                btnLabel.innerHTML = window.variantStrings.preOrder;
              }
              btn_add_cart.disabled = false;
            } else {
              if (btnLabel.innerHTML !== window.variantStrings.addToCart) {
                btnLabel.innerHTML = window.variantStrings.addToCart;
              }
              btn_add_cart.disabled = false;
            }
          } else {
            if (btnLabel.innerHTML !== window.variantStrings.soldOut) {
              btnLabel.innerHTML = window.variantStrings.soldOut;
            }
            btn_add_cart.disabled = true;
          }
        }
      }
    });
    productTarget._syncProductViewPurchaseState?.(av === true);
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }
  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === "INPUT") {
        element.classList.toggle("option-disabled", !availableElement);
      } else if (element.tagName === "OPTION") {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value,
            );
      }
    });
  }
  updateOptions() {
    this.options = [];
    Array.from(this.querySelectorAll("select, fieldset"), (element) => {
      if (element.tagName === "SELECT") {
        let array = element.value.split(" / ");
        array.forEach((item) => this.options.push(item));
      }
      if (element.tagName === "FIELDSET") {
        this.options.push(
          Array.from(element.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value,
        );
      }
    });
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
let swatchDropdownOutsideClickAttached = false;

function syncSwatchDropdownOutsideClick() {
  const hasOpenDropdown = Boolean(document.querySelector(".select-custom.active"));
  if (hasOpenDropdown === swatchDropdownOutsideClickAttached) return;

  if (hasOpenDropdown) {
    document.addEventListener("click", handleSwatchDropdownOutsideClick);
  } else {
    document.removeEventListener("click", handleSwatchDropdownOutsideClick);
  }
  swatchDropdownOutsideClickAttached = hasOpenDropdown;
}

function handleSwatchDropdownOutsideClick(event) {
  if (event.target.closest?.(".select-custom")) return;

  document.querySelectorAll(".select-custom.active").forEach((element) => {
    element.classList.remove("active");
  });
  syncSwatchDropdownOutsideClick();
}

class SwatchDropdownSelectValue extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.activeFilterSort.bind(this));
  }

  activeFilterSort() {
    const dropdown = this.closest(".select-custom");
    if (!dropdown) return;
    this.dropdown = dropdown;

    document.querySelectorAll(".select-custom.active").forEach((element) => {
      if (element !== dropdown) {
        element.classList.remove("active");
      }
    });

    dropdown.classList.toggle("active");
    syncSwatchDropdownOutsideClick();
  }

  disconnectedCallback() {
    this.dropdown?.classList.remove("active");
    syncSwatchDropdownOutsideClick();
  }
}
customElements.define(
  "swatch-dropdown-select-value",
  SwatchDropdownSelectValue,
);

class VariantRadiosDetail extends SwatchFunctions {
  onVariantChange(event) {
    // 无效组合也要取消上一次切色尚未执行的 URL 更新。
    this.cancelUrlUpdate();
    super.onVariantChange(event);
  }

  disconnectedCallback() {
    this.cancelUrlUpdate();
  }

  cancelUrlUpdate() {
    if (this.variantUrlFrame != null) cancelAnimationFrame(this.variantUrlFrame);
    if (this.variantUrlTimer != null) clearTimeout(this.variantUrlTimer);
    this.variantUrlFrame = null;
    this.variantUrlTimer = null;
  }

  updateURL() {
    this.cancelUrlUpdate();
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    const variantId = this.currentVariant.id;
    const pageUrl = window.location.href;

    // rAF 内的回调仍在绘制前执行；下一任务再更新 URL，让颜色/价格先反馈。
    // 保留正常 History 调用链，第三方统计仍能收到变体地址变化。
    this.variantUrlFrame = requestAnimationFrame(() => {
      this.variantUrlFrame = null;
      this.variantUrlTimer = setTimeout(() => {
        this.variantUrlTimer = null;
        if (!this.isConnected || this.currentVariant?.id !== variantId
          || window.location.href !== pageUrl) return;
        super.updateURL();
      }, 0);
    });
  }

  groupFunctionsAvailable(variantQtyData, target) {
    this.updateVariantInput();
    this.updatePrice(this.productTarget);
    this.renderProductInfor(this.productTarget, variantQtyData, target);
    this.setAvailable();
    this.updateURL();
  }
}
customElements.define("variant-radios-detail", VariantRadiosDetail);

// Shared product-form submission; cart page rendering belongs to Cart.
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.disabled || this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const productRoot = this.closest('[id^="MainProduct-"]');
        productRoot?._syncProductViewPurchaseState?.();
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const productInfo = this.form.closest(".product-detail__information");
        if (productInfo) {
          productInfo.querySelectorAll("product-property input").forEach((property) => {
            if (property.classList.contains("file") && property.files[0]) {
              formData.append(property.name, property.files[0]);
            } else if (property.classList.contains("text") && property.value) {
              formData.append(property.name, property.value);
            }
          });
        }
        // Cart owns its section ID and rendering; the old minicart form no longer exists.
        const cartItems = document.querySelector("cart-items");
        const sectionId = cartItems?.sectionId;
        if (sectionId) {
          formData.set("sections", sectionId);
          formData.set("sections_url", window.location.pathname);
        }
        config.body = formData;

        try {
          const result = await fetch(routes.cart_add_url, config);
          const response = await result.json();
          if (!result.ok || response.status || response.errors) {
            const message = response.description || response.errors || window.cartStrings.error;
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: message,
              message: response.message,
            });
            this.handleErrorMessage(message);
            return;
          }
          if (!response.id && !response.items) {
            this.handleErrorMessagePopup(window.cartStrings.error);
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: response,
          });
          // The header cart is only a link; native adds need the cart page when Cart is absent.
          if (!cartItems) {
            window.location.assign(routes.cart_url);
            return;
          }

          const cartResponse = await fetch(`${routes.cart_url}.js`);
          if (!cartResponse.ok) throw new Error("Unable to refresh the cart");
          const cart = await cartResponse.json();
          if (cart.item_count !== undefined) {
            document.querySelectorAll(".cart-count").forEach((element) => {
              element.textContent = element.classList.contains("cart-count-drawer")
                ? `(${cart.item_count})`
                : (cart.item_count > 100 ? "~" : cart.item_count);
            });
          }
          if (sectionId && typeof cartItems.render === "function") {
            cartItems.render({ ...cart, sections: response.sections });
          }
        } catch (error) {
          console.error(error);
          // Network failures must leave the form usable and expose the existing error UI.
          this.handleErrorMessage(window.cartStrings.error);
        } finally {
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          productRoot?._syncProductViewPurchaseState?.();
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      async handleErrorMessagePopup(errorMessage = false) {
        const url = `${window.location.pathname}?section_id=form-message`;
        const fallbackMessage = document.createElement("span");
        fallbackMessage.textContent = String(errorMessage || window.cartStrings.error);
        let content = fallbackMessage.outerHTML;
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`Product form message request failed: ${response.status}`);
          }
          const html = new DOMParser().parseFromString(
            await response.text(),
            "text/html",
          );
          const message = html.querySelector(
            ".product-form__error-message-wrapper .product-form__error-message",
          );
          if (!message) throw new Error("Missing product form error message");
          message.textContent = fallbackMessage.textContent;
          content = message.closest(".product-form__error-message-wrapper").innerHTML;
        } catch (error) {
          console.error("Error loading product form error message:", error);
        }
        showToast(content, 5000, "modal-error");
      }
    },
  );
}

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.hasLoadedProducts = false;
    this.isLoadingProducts = false;
    this.intersectionObserver = null;
    this.popupSearchObserver = null;
  }
  initData() {
    if (this.hasLoadedProducts || this.isLoadingProducts) return;
    let savedProductsArr;
    try {
      savedProductsArr = JSON.parse(
        localStorage.getItem("glozin__recently-viewed-products"),
      );
    } catch {
      savedProductsArr = [];
    }
    // 没有浏览历史时不请求整个搜索 section，也不保留空的占位。
    if (!Array.isArray(savedProductsArr) || savedProductsArr.length === 0) {
      this.remove();
      return;
    }
    this.isLoadingProducts = true;
    this.getStoredProducts(savedProductsArr);
  }
  getStoredProducts(p) {
    const limit = Number(this.dataset.limit) || 6;
    const idsToUse = p.slice(0, limit);
    const productAjaxURL = `&q=id:${idsToUse.join("%20OR%20id:")}`;
    return fetch(`${this.dataset.url}${productAjaxURL}`)
      .then((response) => {
        if (!response.ok) throw new Error(`Product cards request failed: ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, "text/html");
        const results = html.querySelector("[data-product-card-results]");
        if (!results) throw new Error("Missing product card results");
        if (!results.querySelector("[data-product-id]")) {
          this.remove();
          return;
        }
        const styles = [...html.querySelectorAll("style[data-section-stylesheet]")]
          .filter((style) => !results.contains(style));
        this.replaceChildren(...styles, results);
        this.sortRenderedProducts(idsToUse);
        this.hasLoadedProducts = true;
        this.popupSearchObserver?.disconnect();
        this.popupSearchObserver = null;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.isLoadingProducts = false;
      });
  }
  sortRenderedProducts(idsToUse) {
    if (!Array.isArray(idsToUse) || !idsToUse.length) return;

    const wrapper = this.querySelector(".site-header__recent-products-grid");
    if (!wrapper) return;

    const productItems = Array.from(wrapper.children);
    if (!productItems.length) return;

    const productMap = new Map();

    productItems.forEach((item) => {
      const productId = item.dataset.productId;
      if (productId) {
        productMap.set(productId, item);
      }
    });

    if (!productMap.size) return;

    const orderedItems = idsToUse
      .map((productId) => productMap.get(`${productId}`))
      .filter(Boolean);

    if (!orderedItems.length) return;

    orderedItems.forEach((item) => {
      wrapper.appendChild(item);
    });
  }
  setupPopupSearchObserver() {
    const popupSearch = this.closest(".popup-search");
    if (!popupSearch || this.popupSearchObserver) return;

    let wasOpen = false;
    const syncPopupSearchState = () => {
      const isOpen = popupSearch.classList.contains("popup-search-show");
      if (isOpen && !wasOpen) this.initData();
      wasOpen = isOpen;
    };

    syncPopupSearchState();

    if (this.isConnected && !this.hasLoadedProducts && !this.popupSearchObserver) {
      this.popupSearchObserver = new MutationObserver(syncPopupSearchState);
      this.popupSearchObserver.observe(popupSearch, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }
  connectedCallback() {
    this.setupPopupSearchObserver();
    if (!this.isConnected || this.hasLoadedProducts || this.closest(".popup-search")) return;

    const __this = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.intersectionObserver = null;
      __this.initData();
    };

    if (!this.intersectionObserver) {
      this.intersectionObserver = new IntersectionObserver(
        handleIntersection.bind(this),
        {
          rootMargin: "0px 0px 400px 0px",
        },
      );
      this.intersectionObserver.observe(this);
    }
  }

  disconnectedCallback() {
    this.intersectionObserver?.disconnect();
    this.intersectionObserver = null;
    this.popupSearchObserver?.disconnect();
    this.popupSearchObserver = null;
  }
}
customElements.define("recently-viewed-products", ProductRecentlyViewed);

let formatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

setTimeout(function () {
  if (document.querySelector("#cd-opus-scroll-effect")) {
    // The app replaces its list when the drawer changes. Reuse one observer for
    // the current list instead of retaining an observer for every old list.
    let observedList = null;
    let pendingFrame = null;
    const scheduleSwatchCheck = () => {
      if (pendingFrame !== null) return;
      pendingFrame = requestAnimationFrame(() => {
        pendingFrame = null;
        checkOutOfSwatch();
      });
    };
    const listObserver = new MutationObserver(scheduleSwatchCheck);
    const observeCurrentList = () => {
      const list = document.querySelector(".cd-product-list");
      if (list === observedList) return;
      listObserver.disconnect();
      observedList = list;
      if (!list) return;
      listObserver.observe(list, { childList: true, subtree: true });
      scheduleSwatchCheck();
    };

    observeCurrentList();
    const drawer = document.querySelector(".drawer-cd-up-app-Ksl");
    if (drawer) {
      const drawerObserver = new MutationObserver(observeCurrentList);
      drawerObserver.observe(drawer, { attributes: true, attributeFilter: ["class"] });
    }
  }
  if (document.querySelector("#opus-checkout-btn")) {
    const divOut1 = document.createElement("div");
    const divOut2 = document.createElement("div");
    divOut1.innerHTML = `<div class="theme-cart-notice__hint">Up to 25% OFF code applies at checkout
</div>`;
    divOut2.innerHTML = `<div class="theme-cart-notice__link"><a href="/cart">view cart</a></div>`;
    document
      .querySelector("#opus-checkout-btn")
      .insertAdjacentElement("afterEnd", divOut2);
    document
      .querySelector("#opus-checkout-btn")
      .insertAdjacentElement("afterEnd", divOut1);
  }
}, 5000);
function checkOutOfSwatch() {
  const checkoutButton = document.querySelector(".cd-checkout-section-button.cd-main-button");
  if (!checkoutButton) return;
  let cartTotal = 0;
  document.querySelectorAll(".cd-product-item-details").forEach((item) => {
    if (!item.querySelector(".cd-product-item-title")?.innerText.includes("#")) return;
    cartTotal += Number(item.querySelector(".cd-number-input-field")?.value || 0);
  });
  if (cartTotal <= 5) {
    checkoutButton.classList.remove("disabled");
    if (document.querySelector("#payment-express")) {
      document.querySelector("#payment-express").style.display = "block";
    }

    if (document.querySelector(".out-of-free-swt")) {
      document.querySelector(".out-of-free-swt").style.display = "none";
    }
  } else {
    if (document.querySelector(".out-of-free-swt")) {
      document.querySelector(".out-of-free-swt").style.display = "block";
      // document.querySelector('.out-of-cartToal').innerText=cartTotal
      const excessCount = document.querySelector(".out-of-cartToal2");
      if (excessCount) excessCount.textContent = cartTotal - 5;
    } else {
      const divOut = document.createElement("div");
      divOut.classList.add("out-of-free-swt");
      divOut.innerHTML = `<div class="theme-cart-notice__excess"> Number of swatches exceeded. Please remove <span class="out-of-cartToal2">${
        cartTotal - 5
      }</span> before checking out.</div>`;
      checkoutButton.insertAdjacentElement("afterEnd", divOut);
      if (document.querySelector("#opus-checkout-btn")) {
        document
          .querySelector("#opus-checkout-btn")
          .insertAdjacentElement("beforeBegin", divOut);
      }
    }
    checkoutButton.classList.add("disabled");
  }
}
